
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./app": () => {
return Promise.all(/*  | __federation_expose_app */ [__webpack_require__.e("6440"), __webpack_require__.e("8068"), __webpack_require__.e("7465"), __webpack_require__.e("94"), __webpack_require__.e("7194")]).then(() => (() => (__webpack_require__(82472))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };